import ForResearches from 'components/pagesComponents/landing/ForResearches';

import anonymousPageProps from 'utils/anonymousPageProps';

export default ForResearches;

export const getServerSideProps = anonymousPageProps;
